

export const environment = {
  production: false,
  apiHost:      'http://localhost:4200',
  apiUrl:       'api',
  apiVersion:   'v1'
};


